import React from "react";
import Render from "@gqlapp/theme";
import template from "./list.html.twig";
import { sharedPartials } from "@modules/layout/partials";
import { fetchMenu, fetchList } from "@lib/content/fetch";
import { cleanPath, toTeasers } from "@lib/content/normalize";
import { buildPager, currentPage } from "@lib/content/pager";
import VIDEOS_QUERY from "@modules/video/graphql/VideosQuery.graphql";

const PAGE_SIZE = 20;
const EMPTY = { title: '', media: [], pager: [], categories: [] };

export default function ListContainer(props: any){
	const { videoListData } = props;
	return <>
		<Render {...{ template, context: { partials: { ...sharedPartials }, ...EMPTY, ...(videoListData || {}) } }} />
	</>;
}

ListContainer.getInitialProps = async (ctx: any) => {
	const { apolloClient } = ctx || {};
	const id = Number(ctx?.graphqlRoute?.id);
	const page = currentPage(ctx?.query);
	const basePath = cleanPath(ctx?.path);
	const title = ctx?.graphqlRoute?.title || '';

	try {
		const [list, categories] = await Promise.all([
			id > 0
				? fetchList(apolloClient, VIDEOS_QUERY, { page, pageSize: PAGE_SIZE, filter: { tids: [id] } })
				: Promise.resolve({ edges: [], total: 0 }),
			fetchMenu(apolloClient, 'video'),
		]);
		return { videoListData: { title, media: toTeasers(list.edges), pager: buildPager({ basePath, page, total: list.total, pageSize: PAGE_SIZE }), categories } };
	} catch (e) {
		debug(e);
		return { videoListData: { ...EMPTY, title } };
	}
};
